import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MavenSettingsDialogComponent } from './maven-settings-dialog.component';
import { DevExtremeModule } from '../devextreme.module';

// CR-20260910-001 (2026-09-14): Maven Settings split out of ORION Settings. The settings record
// itself stays on OrionSettingsService (providedIn root).
@NgModule({
   declarations: [
      MavenSettingsDialogComponent
   ],
   imports: [
      CommonModule,
      DevExtremeModule
   ],
   exports: [
      MavenSettingsDialogComponent
   ]
})
export class MavenSettingsDialogModule {}
